import api from './api_resource';
import LaravelRouter from "../thirdparty/Ziggy/route";
import axios from "axios/index";

export default {
    show(resource, id, args) {
        args = args ? {params: args} : null;
        return new Promise((success, error) => {
            let route = LaravelRouter(`${resource}.show`, id, true);
            axios.get(route, args).then(response => {
                if (response && response.data && response.data) {
                    success(response.data)
                } else {
                    error(response);
                }
            }).catch(response => {
                error(response);
            });
        });
    },
}


// WEBPACK FOOTER //
// ./resources/js/api/recommendedvehicle.js